
<template>
  <!--系统消息-->
  <div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'systemMsg',
  data () {
    return {
      searchList: [
        { props: ['title'], placeholder: '标题', inputType: 'input' },
        { props: ['aims'], placeholder: '应用', options: [], inputType: 'select' },
        { props: ['status'], placeholder: '状态', options: this.$store.state.sendStatusList, inputType: 'select' },
        { props: ['scopeType'], placeholder: '用户范围', options: [], inputType: 'select' },
        { props: ['createDate'], placeholder: ['发布时间', '发布时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', permi: ['community:message:add'] }
      ],
      rowOptList: [
        { text: '修改', handle: (record) => this.$refs.table.toEdit(record), permi: ['community:message:edit'] },
        { text: '删除', handle: (record) => this.$refs.table.showDeleteConfirm(record), permi: ['community:message:remove'] }
      ],
      columns: [
        { title: '标题', dataIndex: 'title', align: 'left', width: '' },
        { title: '发布时间', dataIndex: 'createTime', align: 'left', width: '' },
        { title: '状态', dataIndex: 'statusDesc', align: 'left', width: '' },
        { title: '应用', dataIndex: 'aimsDesc', align: 'left', width: '' },
        { title: '用户范围', dataIndex: 'scopeTypeDesc', align: 'left', width: '' },
        { title: '送达 | 阅读', dataIndex: 'sendAndRead', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        title: undefined,
        aims: undefined,
        status: undefined,
        scopeType: undefined,
        createDate: undefined
      },
      listApi: {
        url: '/messageList/list',
        resHandle: this.resHandle, // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addSystemMsg',
        addTitle: '新增系统消息',
        editTitle: '修改系统消息'
      },
      deleteParam: {
        url: '/messageList/',
        // param: { pk_key: 'id', pk_val: '' },
        title: '系统消息',
        key: 'title'
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      let paramArr = [
        {index: 1, scope: 'searchList', query: 'comu_msg_aims'},
        {index: 3, scope: 'searchList', query: 'comu_msg_scope_type'}
      ];
      this.dictionarySelect(paramArr);
    },
    resHandle (res) {
      res.forEach((el) => {
        el.sendAndRead = `${el.totalNum} | ${el.readNum}`;
      });
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>
